<nav class="navbar navbarcustom">
  <div class="container-fluid">
    @if (!isMobileSearch) {
    <a class="navbar-brand d-flex align-items-center" (click)="navigateHome()">
      <span class="custom-logo">
        <img src="/assets/images/TMCV-New-Logo.png" alt="Tata Motors Commercial Vehicles" height="42"
          class="d-inline-block" />
        &nbsp;
      </span>
      &nbsp;
      <span class="navbar-text ms-2">FleetCare</span>
      <!-- <span>
        <button  (click)="detectMobileView(true)"class="navbar-toggler d-block d-md-none" type="button" >
          <span class="navbar-toggler-icon"></span>
        </button>
      </span> -->
    </a>
    <i class="ti ti-menu-2 ti-md t-menu d-block d-md-none" (click)="detectMobileView(true)"></i>
    <!-- <a class="navbar-brand">
    <span class="logo">
      <img src="/assets/images/TMCV-New-Logo.png" height="42" />
    </span>
  </a> -->
    @if (position_name) {
    <div class="text-center  d-md-block flex-grow-1-se search-container position-relative">
      <small class="text badge bg-label-primary" style="color: black; font-weight: 500; cursor: pointer;"
        (click)="this.getPositions();">{{ position_name }}</small>
    </div>
    }
    <form class="d-flex">
      <ul class="navbar-nav flex-row align-items-center ms-auto">
        <!-- <li>
      <small class="text">{{ position_name }}-{{ subuserType }}</small>
    </li> -->
        @if (variant === 'dealer') {
        <li>
          <button class="btn btn-tata-motors btn-lg" (click)="createVasorder(true)">Book VAS</button>&nbsp;&nbsp;
        </li>
        }
        <li class="d-block d-md-none">
          <i class="ti ti-search ti-md t-menu" (click)="SerachMbInfo()"></i>
        </li>
        <li><button class="nav-link btn btn-text-secondary btn-icon rounded-pill help-button" type="button"
            (click)="openHelpSidebar()" aria-label="Open help"><i class="ti ti-help ti-md t-menu"></i><span
              class="help-label">Help</span></button></li>
        <li class="after-link left-bell-mb-icon nav-item ">
          <a class="nav-link btn btn-text-secondary btn-icon rounded-pill " href="javascript:void(0);"
            data-bs-auto-close="outside" aria-expanded="false" (click)="navigateHome()">
            <span class="position-relative">
              <!-- bx bx-search bx-md -->
              <i class="ti ti-home ti-md t-menu"></i>
            </span>
          </a>
        </li>
        <li class="nav-item navbar-dropdown dropdown-user dropdown setting-details">
          <a class="nav-link dropdown-toggle hide-arrow p-0" href="javascript:void(0);" data-bs-toggle="dropdown">
            <div class="avatar avatar-online all-option">
              <img src="/assets/img/avatars/1.png" alt class="rounded-circle" (click)="userProfile()" />
            </div>
          </a>
          <ul class="dropdown-menu dropdown-menu-alloption dropdown-menu-end">
            <li>
              <a class="dropdown-item mt-0" href="javascript:void(0)">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <div class="avatar avatar-online">
                      <img src="/assets/img/avatars/1.png" alt class="rounded-circle" />
                    </div>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-0">{{ username || "Guest" }}</h6>
                    @if (variant === 'gdc') {
                    <small class="text-muted">{{ position_name }}</small>
                    } @else {
                    <small class="text-muted">{{ userType || "User" | uppercase }}-{{subuserType}}</small>
                    }
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="dropdown-divider my-1 mx-n2"></div>
            </li>
            @if (variant === 'dealer' || userType !== 'approver') {
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="getPositions()">
                <i class="ti ti-settings me-3 ti-md"></i>
                <span class="align-middle">Change Position</span>
              </a>
            </li>
            }
            <!-- <li>
    <a class="dropdown-item" href="javascript:void(0)">
      <i class="ti ti-user me-3 ti-md"></i
        ><span class="align-middle">My Profile</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" href="javascript:void(0)">
        <i class="ti ti-settings me-3 ti-md"></i
          ><span class="align-middle">Settings</span>
        </a>
      </li> -->
            <li>
              <div class="d-grid px-2 pt-2 pb-1">
                <a class="btn btn-sm btn-logout d-flex" (click)="logout()">
                  <small class="align-middle">Logout</small>
                  <i class="ti ti-logout ms-2 ti-14px"></i>
                </a>
              </div>
            </li>
          </ul>
        </li>
        <!-- <li class="d-block d-md-none">
  <i
    class="ti ti-menu-2 ti-md t-menu"
    (click)="detectMobileView(true)"
  ></i>
</li> -->
      </ul>
    </form>
    }
    @if (isMobileSearch) {
    <div class="container-fluid d-flex justify-content-between align-items-center">
      <input class="form-control w-100 me-2 t-search-bg" type="search" placeholder="For eg: Dealer name, Dealer ID"
        aria-label="Search" />
      <i class="ti ti-x search-toggler cursor-pointer t-menu" (click)="SerachMbInfo()"></i>
    </div>
    <!-- <div><input class="form-control me-2" type="search" placeholder="Search" aria-label="Search"></div>
  <div>2</div> -->
    <!-- <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
  <i class="ti ti-x search-toggler cursor-pointer" (click)="SerachMbInfo()"></i> -->
    }

    <i class="ti ti-menu-2 ti-md t-menu ipadview" (click)="detectMobileView(true)"></i>
  </div>
</nav>

<p-drawer [(visible)]="helpSidebar" position="right" styleClass="help-drawer">
  <ng-template pTemplate="header">
    <div>
      <span class="help-eyebrow">SUPPORT</span>
      <h5 class="mb-0">Help centre</h5>
    </div>
  </ng-template>

  <div class="help-intro">Useful documents and resources for your day-to-day work.</div>

  <label class="help-search">
    <i class="ti ti-search"></i>
    <input [(ngModel)]="helpSearch" placeholder="Search documents" aria-label="Search documents" />
  </label>

  <div class="help-documents">
    @if (helpDocumentsLoading) {
    <p class="text-muted small mt-4">Loading documents...</p>
    } @else if (helpDocumentsError) {
    <p class="text-muted small mt-4">Unable to load documents. Close and reopen Help to try again.</p>
    } @else {
      @for (doc of filteredHelpDocuments; track doc.document_name) {
      <a class="help-document" [href]="doc.document_url" target="_blank" rel="noopener noreferrer">
        <span class="document-icon"><i class="ti ti-file-text"></i></span>
        <span class="document-copy">
          <strong>{{ doc.document_name }}</strong>
          <small>{{ doc.created_date | date:'dd-MMM-yyyy HH:mm:ss' }}</small>
        </span>
        <i class="ti ti-external-link document-arrow"></i>
      </a>
      } @empty {
      <p class="text-muted small mt-4">No documents found.</p>
      }
    }
  </div>

  <a class="faq-link" [routerLink]="variant === 'gdc' ? '/tml/faq' : '/dealer/faq'" (click)="helpSidebar = false">
    <i class="ti ti-message-question"></i> Browse all FAQs <i class="ti ti-arrow-right"></i>
  </a>
</p-drawer>


<div class="card flex justify-content-center sidebar">
  <p-drawer [(visible)]="positionSidebar" position="right">
    <ng-template pTemplate="header">
      <div class="d-flex flex-column mb-2">
        <h5 class="mb-3"><strong>Select Your Position </strong></h5>
      </div>
    </ng-template>
    <div class="container">
      <div class="row mt-4">
        <div class="col-12">
          <div class="list-group" style="min-width: 100%;">

            @for (pos of visiblePositions; track pos.position) {
            <label class="list-group-item list-group-item-action d-flex align-items-center position-item"
              [class.disabled]="!pos.allowed_position" [class.selected]="pos.active">
              <input type="radio" name="position" [value]="pos.position" [disabled]="!pos.allowed_position"
                [checked]="pos.active" (change)="onPositionChange(pos)" class="form-check-input me-2" />
              <span class="ms-1"><strong>{{pos.position_type}} - {{ pos.position }}</strong>@if (pos.active) {
                <span class="badge bg-primary ms-2">Active</span>
                }</span>
            </label>
            }

          </div>
        </div>
      </div>




    </div>
    <ng-template pTemplate="footer">
      <div class="d-flex align-items-end justify-content-center gap-2 p-2" style="border-top: 1px solid #cfcfcf;">
        <button class="btn btn-navy w-100" (click)="updatePosition()">Update</button>
      </div>
    </ng-template>
  </p-drawer>
</div>